export const TOGGLE_VIDEO_MUTE = 'events/TOGGLE_VIDEO_MUTE';

/**
 * @return {{type: string}}
 */
export const toggleVideoMute = (payload) => ({ type: TOGGLE_VIDEO_MUTE, payload });
